import React from "react";
import backArrow from "../../../assets/icons/Back.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import bettingService from "../../../api/services/bettingService";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { IoIosArrowBack } from "react-icons/io";

const OldMatchesPage = ({ setIsLoading }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { oldHistory } = useSelector(state => state.sidebar);
    const { id } = useParams();
    const { t } = useTranslation();
    const [oldMatches, setOldMatches] = useState([]);
    const language = localStorage.getItem("language");
    const profitAmount = oldHistory ? (oldHistory?.profitAmount >= 0 ? oldHistory.profitAmount : 0) : 0;
    const winAmount = Math.max(profitAmount - (oldHistory?.amount || 0), 0);

    const handleBackClick = async () => {
        dispatch(playSong());
        navigate("/old-histories");
    };

    useEffect(() => {
        setIsLoading(true);
        bettingService.bettingHistoryDetails({
            "gamblingId": Number(id),
            "status": "Finished"
        })
            .then(response => response.json())
            .then(data => {
                if (data) {
                    const sortedData = data.slice().sort((a, b) => {
                        const dateA = new Date(
                            a.eventDate.split(' ')[0].split('-').reverse().join('-') + ' ' + a.eventDate.split(' ')[1]
                        );
                        const dateB = new Date(
                            b.eventDate.split(' ')[0].split('-').reverse().join('-') + ' ' + b.eventDate.split(' ')[1]
                        );
                        return dateA - dateB;
                    });
                    setOldMatches(sortedData)
                }
                setIsLoading(false);
            })
            .catch(err => {
                setIsLoading(false);
                console.error("API request error:", err);
            });
    }, [id, navigate, setIsLoading]);

    return (
        <div className="flex flex-col w-full h-[100dvh] overflow-hidden dark:bg-bg_header_dark">
            <div className="flex items-center justify-start py-2 border-b dark:border-b dark:border-slate-700 dark:shadow-sm bg-k_teamsBgColor dark:bg-bg_header_dark">
                <button
                    className="flex items-center justify-center w-10 h-10 text-4xl text-white rounded-full top-3 left-5 drop-shadow-lg"
                    onClick={handleBackClick}
                >
                    {/* <img src={backArrow} alt="Back Arrow" /> */}
                    <IoIosArrowBack size={25} className="text-black" />
                </button>
                <div className="items-center justify-center flex-1">
                    <h3 className="ml-2 text-black mr-7 text-start">
                        {t("oldMatches")}
                    </h3>
                </div>
            </div>
            <div className="mt-2 mr-3 text-sm text-primary dark:text-league_text text-end font-dangrek">BetID : {oldHistory?.postingNo}</div>
            <div className="flex-1 p-2 overflow-auto">
                {oldMatches.map((match, index) => {
                    const bettedTeam = language === "en" ? match?.bettedTeam : match?.bettedTeamMyan;
                    const oppositeTeamName = language === "en" ? match?.oppositeTeamName : match?.oppositeTeamNameMyan;
                    return (
                        <div key={index} className="flex flex-col px-2 py-4 mb-2 rounded-md bg-k_groupBgColorEight">
                            <div className="flex items-center justify-between mb-1 text-xs font-thin sm:text-sm md:text-base text-k_leagueFgColor dark:text-white">
                                <p className="text-left text-white rounded-lg dark:text-time_dark font-dangrek">
                                    {match?.eventDate}
                                </p>
                            </div>
                            <div className="grid grid-cols-9 gap-[1px] mb-1">
                                <div
                                    className={`${match?.home === true
                                        ? "bg-k_selectionBgColor text-k_selectionFgColor"
                                        : "bg-k_teamsBgColor text-k_teamsFgColor"
                                        } rounded-lg py-2 px-1 flex items-center col-span-4`}
                                >
                                    <h3
                                        className={`ml-auto font-normal text-center dark:text-white text-sm ${match?.home === true ? "text-k_selectionFgColor" : "text-k_teamsFgColor"
                                            } sm:text-base md:text-base ${match?.isHomeBodyOdd === false
                                                ? "flex flex-1 items-center justify-center"
                                                : "flex flex-1 justify-center"
                                            }`}
                                    >
                                        {match.isHome ? bettedTeam : oppositeTeamName}
                                    </h3>
                                    {match.isHomeBodyOdd === true && (
                                        <h3 className="p-1 text-xs font-bold rounded-lg bg-k_priceBgColor text-k_priceFgColor text-xxs sm:text-sm md:text-base whitespace-nowrap">
                                            {match?.bodyOdd}
                                        </h3>
                                    )}
                                </div>
                                {/* <div className="flex flex-row justify-center gap-[1px]">
                                    <div className="cursor-not-allowed text-center w-[20px] bg-red-600 rounded-md p-[3px] flex justify-center items-center ">
                                        <h3 className="font-semibold text-center text-[#fff] text-base sm:text-sm md:text-base">
                                            {match?.homeResult}
                                        </h3>
                                    </div>
                                    <div className="cursor-not-allowed text-center w-[20px] bg-red-600 rounded-md p-[3px] flex justify-center items-center ">
                                        <h3 className="font-semibold text-center text-[#fff] text-base sm:text-sm md:text-base">
                                            {match?.awayResult}
                                        </h3>
                                    </div>
                                </div> */}
                                <div className="flex items-center justify-center w-full text-xs text-center text-white rounded-lg bg-k_goalscoreBgColor font-dangrek">{`${match?.homeResult}-${match?.awayResult}`}</div>
                                <div
                                    className={`${match?.away === true
                                        ? "bg-k_selectionBgColor text-k_selectionFgColor"
                                        : "bg-k_teamsBgColor text-k_teamsFgColor"
                                        } rounded-lg py-3 px-1 flex justify-center items-center col-span-4`}
                                >
                                    {match?.isHomeBodyOdd === false && (
                                        <h3 className="p-1 text-xs font-bold rounded-lg bg-k_priceBgColor price text-k_priceFgColor text-xxs sm:text-sm md:text-base">
                                            {match?.bodyOdd}
                                        </h3>
                                    )}
                                    <h3
                                        className={` flex flex-1 w-full justify-center text-center font-normal dark:text-white text-sm sm:text-base md:text-base ${match?.isHomeBodyOdd === true &&
                                            "flex flex-1 justify-center items-center"
                                            }`}
                                    >
                                        {!match.isHome ? bettedTeam : oppositeTeamName}
                                    </h3>
                                </div>
                            </div>
                            <div className="grid grid-cols-5 gap-1">
                                <div
                                    className={`${match?.overs === true
                                        ? "bg-k_selectionBgColor text-k_selectionFgColor"
                                        : "bg-k_teamsBgColor text-k_teamsFgColor"
                                        } rounded-lg p-1 col-span-2`}
                                >
                                    <h3 className="py-2 text-sm font-normal text-center dark:text-white sm:text-sm md:text-base">
                                        {t("goalOver")}
                                    </h3>
                                </div>
                                <div className="flex items-center justify-center p-1 text-center rounded-lg cursor-not-allowed bg-k_priceBgColor ">
                                    <h3 className="text-xs font-bold text-center text-k_priceFgColor sm:text-sm md:text-base">
                                        {match?.goalOdd}
                                    </h3>
                                </div>
                                <div
                                    className={`${match?.under === true
                                        ? "bg-k_selectionBgColor text-k_selectionFgColor"
                                        : "bg-k_teamsBgColor text-k_teamsFgColor"
                                        } text-center rounded-lg p-1 col-span-2 flex justify-center items-center`}
                                >
                                    <h3 className="text-sm font-normal text-center dark:text-white sm:text-sm md:text-base">
                                        {t("goalUnder")}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            {/* <div className="w-full flex flex-col bg-k_teamsBgColor dark:border-t-2 border-slate-500 dark:border-black/[0.2] dark:bg-bg_header_dark font-dangrek text-white h-max pl-20 py-4">
                <div className="grid grid-cols-2 gap-4 py-1 text-black  border-2 border-crimson/30 ">
                    <h4>{t("betAmount")}</h4>
                    <p >{oldHistory?.amount}</p>
                </div>
                <div className="grid grid-cols-2 gap-4 py-1 text-black">
                    <h4>{t("profitAmount")}</h4>
                    <p>{profitAmount}</p>
                </div>
                <div className="grid grid-cols-2 gap-4 py-1 text-black">
                    <h4>{t("winAmount")}</h4>
                    <p className="text-win">{winAmount}</p>
                </div>
            </div> */}
            <div className="w-full flex flex-col bg-k_teamsBgColor dark:border-t-2 border-slate-500 dark:border-black/[0.2] dark:bg-bg_header_dark font-dangrek text-white h-max py-4 px-4 ">

                {/* Container for the stat boxes to keep them centered and consistent width */}
                <div className="flex flex-col gap-2 w-full max-w-sm mx-auto border-2 border-crimson/30 rounded-lg">

                    {/* Bet Amount - The "Featured" box with the border */}
                    <div className="grid grid-cols-2 gap-4 py-2 text-black bg-white/5 dark:text-white ">
                        <h4 className="flex items-center justify-center border-r border-crimson/10 text-sm opacity-80">{t("betAmount")}</h4>
                        <p className="flex items-center justify-center font-bold">{oldHistory?.amount}</p>
                    </div>

                    {/* Profit Amount */}
                    <div className="grid grid-cols-2 gap-4 py-1 text-black dark:text-white">
                        <h4 className="flex items-center justify-center text-sm opacity-80">{t("profitAmount")}</h4>
                        <p className="flex items-center justify-center font-bold">{profitAmount}</p>
                    </div>

                    {/* Win Amount */}
                    <div className="grid grid-cols-2 gap-4 py-1 text-black dark:text-white">
                        <h4 className="flex items-center justify-center text-sm opacity-80">{t("winAmount")}</h4>
                        <p className="flex items-center justify-center font-bold text-win">{winAmount}</p>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default OldMatchesPage;
